// extracted by mini-css-extract-plugin
module.exports = {"form":"signIn_form__4rJff","signUp":"signIn_signUp__eQfeY"};